"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleFeedbackContextResource = handleFeedbackContextResource;
const getState_1 = require("../../../app/dist/getState");
const getFeedbackContext_1 = require("../../../app/dist/getFeedbackContext");
const dist_1 = require("../../../fs/dist");
const os = __importStar(require("os"));
const fs = __importStar(require("fs-extra"));
// Lockstep version — the mcp package shares the one Loom version, so its own
// package.json is the truthful source to report (no hardcoded string to drift).
const pkg = require('../../package.json');
/**
 * loom://feedback-context — read-only. Assembles the fixed feedback-sink repo,
 * the non-PII usage snapshot, and the prefilled issue-form URL. The extension
 * reads this and opens `url`; nothing is sent from here.
 */
async function handleFeedbackContextResource(root, _uri) {
    const registry = new dist_1.ConfigRegistry();
    const ctx = await (0, getFeedbackContext_1.getFeedbackContext)({ loomVersion: pkg.version }, {
        getState: () => (0, getState_1.getState)({ getActiveLoomRoot: dist_1.getActiveLoomRoot, loadWeave: dist_1.loadWeave, buildLinkIndex: dist_1.buildLinkIndex, registry, fs, workspaceRoot: root }),
        platform: () => os.platform(),
    });
    return {
        contents: [{
                uri: 'loom://feedback-context',
                mimeType: 'application/json',
                text: JSON.stringify(ctx, null, 2),
            }],
    };
}
